import {Button, Dropdown, Menu, Pagination, Table, Spin, Tag as AntdTag} from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import CreateResource from "../../../components/CreateResource/CreateResource";
import Icon from "../../../components/Icon/Icon";
import Spinner from "../../../components/Spinner/Spinner";
import { Props, Recording, TabStatus } from "./RecordingsTab.model";
import styles from "./RecordingsTab.module.scss";
import { pageSize, useRecordingsTab } from "./useRecordingsTab";
import Tag from "../../../components/Tag/Tag";
import ErrorMessage from "../../../components/ErrorMessage/ErrorMessage";
import moment from "moment";
import Popup from "../../../components/Popup/Popup";

const RecordingsTab = ({ filters }: Props) => {
	const {
	getRecordings,
		onChangePagination,
		onDeleteRecordig,
		setShowCreateResource,
		setRecordingToBeDeleted,
		state: {
			pagination,
			pending,
			recordings,
			showCreateResource,
			recordingToBeDeleted,
			tabStatus,
			user
		},
	} = useRecordingsTab({ filters });

	const intl = useIntl();

	const renderDropdown = (item: Recording) => {
		return <Menu>
			<Menu.Item key="1">
				<Button type="link" download href={item.link} className={styles.blueBtn}>
					<FormattedMessage id="buttons.download" />
				</Button>
				</Menu.Item>
				<Menu.Item key="2">
				<Button type="link" className={styles.redBtn} onClick={() =>  {setRecordingToBeDeleted(item.id)}}>
					<FormattedMessage id="buttons.delete" />
				</Button>
			</Menu.Item>
		</Menu>
	}

	const renderSnackBar = () => {
		return <div className={styles.snackBar}>
			<Spin spinning={true} />
			<p><FormattedMessage id="media.pending" /></p>
			<Button onClick={getRecordings} type="text">
				<FormattedMessage id="buttons.refresh" />
			</Button>
		</div>
	}

	const recordingsColumns = [
		{
			dataIndex: 'name',
			title: intl.formatMessage({ id: "table.column.name" })
		},
		{
			dataIndex: 'timestamp',
			render: (date: string) => moment(date).format("DD MMM YYYY"),
			title: intl.formatMessage({ id: "table.column.date" })
		},
		{
			render: (record: Recording) => <div className={styles.tableActions} >
				<Button type="default" className={styles.blueBtn} size="large" onClick={() => { setShowCreateResource(record.id)}}>
					<FormattedMessage id="buttons.createResource" />
				</Button>
				<Dropdown overlay={renderDropdown(record)}>
					<div className={styles.iconWrapper} ><Icon name="ellipsis-h" color="text" /> </div>
				</Dropdown>
			</div>
		}
	];

	return <div className={styles.tabContent}>
		<Spinner spinning={tabStatus === TabStatus.Loading} />
		<ErrorMessage onRefresh={getRecordings} showReport={true} error={tabStatus === TabStatus.Error}/>
		<div className={styles.table}>
			<Table
				columns={recordingsColumns}
				dataSource={recordings}
				pagination={false}
				rowKey={(record) => record.id}
			/>
		</div>
		<div className={styles.contentMobile}>
			{recordings?.map((recording) => {
				return (
					<div className={styles.card}>
						<div className={styles.cardContainer}>
							<div>
								<div className={styles.row}>
									<h2 className={styles.label}>
										<FormattedMessage id="table.column.name" />
									</h2>
									<span>{recording.name}</span>
								</div>
								<div className={styles.row}>
									<h2 className={styles.label}>
										<FormattedMessage id="table.column.date" />
									</h2>
									<span>
										{moment(recording.timestamp).format("DD MMM YYYY")}
									</span>
								</div>
								<div className={styles.assign}>
									<Button
										type="default"
										className={styles.blueBtn}
										size="large"
										onClick={() => {
											setShowCreateResource(recording.id);
										}}
									>
										<FormattedMessage id="buttons.createResource" />
									</Button>
								</div>
								<div className={styles.assign}>
									<Button
										type="link"
										download
										href={recording.link}
										className={styles.blueBtn}
									>
										<FormattedMessage id="buttons.download" />
									</Button>
									<Button type="link" className={styles.redBtn}>
										<FormattedMessage id="buttons.delete" />
									</Button>
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</div>
		
		<div className={styles.paginationWrapper}>
			<Pagination
				className={styles.pagination}
				current={pagination.page}
				pageSize={pageSize}
				total={pagination.total}
				onChange={onChangePagination}
				showSizeChanger={false}
			/>
		</div>
		{showCreateResource && <CreateResource onClose={()=>{setShowCreateResource('')}} author={user} recordingId={showCreateResource} />}
		{pending && renderSnackBar()}
		{recordingToBeDeleted && (
			<Popup
				actions={<div className={styles.popupActions}>
							<Button size="large" type="primary" onClick={onDeleteRecordig}>
								<FormattedMessage id="buttons.delete" />
							</Button>
					<Button size="large" type="default" onClick={() => { setRecordingToBeDeleted('') }}>
								<FormattedMessage id="buttons.cancel" />
							</Button>
						</div>}
				onClose={() => { setRecordingToBeDeleted('') }}
				title={{ action: '', target: '' }}>
					<div className={styles.popupContent}>
						<Icon name="trash" color="accent" width="100px" height="100px" />
						<h1>
							<FormattedMessage id="popupTitles.deleteConfirmation" />
						</h1>
					</div>
				</Popup>
			)}
	</div>
}
export default RecordingsTab;